<template>
  <div class="main">
    <div class="guanli">
      <div class="title">
        <div class="guanli-icon"></div>
        <div class="guanli-ziti">最近使用</div>
      </div>
      <div class="label">
        <!-- <div
          class="label-item"
          style="margin-left: 21px"
          @click="zdspIndex"
          :class="{ mouseover: active == 4 }"
          @mouseover="Mouseover(1)"
          @mouseleave="Mouseleave()"
        >
          <img class="item-img" src="../../assets/icons/pcindex/19@2x.png" />
          <div class="spans">
            <span class="span-t1">期刊审核</span>
            <span class="span-t2">审核已提交的期刊创建 及修改申请</span>
          </div>
        </div> -->
        <div
          class="label-item"
          style="margin-left: 21px"
          @click="journalsindex"
          :class="{ mouseover: active == 4 }"
          @mouseover="Mouseover(1)"
          @mouseleave="Mouseleave()"
        >
          <img class="item-img" src="../../assets/icons/pcindex/33@2x.png" />
          <div class="spans">
            <span class="span-t1">期刊审核</span>
            <span class="span-t2">审核已提交的期刊创建 及修改申请</span>
          </div>
        </div>
        <!-- <div
          class="label-item"
          @click="bakindex"
          :class="{ mouseover: active == 5 }"
          @mouseover="Mouseover(1)"
          @mouseleave="Mouseleave()"
        >
          <img class="item-img" src="../../assets/icons/pcindex/21@2x.png" />
          <div class="spans">
            <span class="span-t1">备案库</span>
            <span class="span-t2">查看已经完成的阵地、 内容备案</span>
          </div>
        </div> -->
        <div
          class="label-item"
          @click="cmckindex"
          :class="{ mouseover: active == 6 }"
          @mouseover="Mouseover(1)"
          @mouseleave="Mouseleave()"
        >
          <img class="item-img" src="../../assets/icons/pcindex/23@2x.png" />
          <div class="spans">
            <span class="span-t1">词库维护</span>
            <span class="span-t2">对错敏词工具进行词库 维护</span>
          </div>
        </div>
        <!-- <div
          class="label-item"
          @click="zdmanage"
          :class="{ mouseover: active == 6 }"
          @mouseover="Mouseover(1)"
          @mouseleave="Mouseleave()"
        >
          <img class="item-img" src="../../assets/icons/pcindex/zd.png" />
          <div class="spans">
            <span class="span-t1">阵地类型管理</span>
            <span class="span-t2">自定义阵地名称、类型</span>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { useRouter } from "vue-router";
export default {
  data() {
    return {
      active: 0, // 悬停区域原始颜色
      background: "",
    };
  },
  setup() {
    const router = useRouter();
    const zdspIndex = () => {
      router.push("zdspIndex");
    };
    const bakindex = () => {
      router.push("bakindex");
    };
    const cmckindex = () => {
      router.push("cmckindex");
    };
    const zdmanage = () => {
      router.push("zdmanage");
    };
    const journalsindex = () => {
      router.push("journalsindex");
    };
    return {
      bakindex,
      zdspIndex,
      cmckindex,
      zdmanage,
      journalsindex,
    };
  },
  methods: {
    // 鼠标"悬停"触发此方法
    Mouseover(num) {
      this.active = num; //
      this.background = "cursor:pointer;background-color:#F6F7FA"; // 进入 悬停区域,更改颜色
    },
    // 鼠标"离开"触发此方法
    Mouseleave() {
      this.active = ""; // 离开 悬停区域,文字颜色复原
    },
  },
};
</script>

<style lang="scss" scoped>
.mouseover {
  background-color: #f6f7fa;
}

@media screen and (min-width: 960px) {
  .main {
    width: 928px;
  }
}

@media screen and (min-width: 1200px) {
  .main {
    width: 928px;
  }
}
.main {
  margin: 0 auto;
}
.guanli {
  height: 372px;
  background: #ffffff;
  border-radius: 10px;
  margin: 16px;
  .title {
    height: 22px;
    display: flex;
    align-items: center;
    padding-left: 21px;
    padding-top: 24px;
    padding-bottom: 8px;
    .guanli-icon {
      width: 4px;
      height: 14px;
      background: #286cfb;
      border-radius: 3px;
      margin-left: 3px;
      margin-right: 9px;
    }

    .guanli-ziti {
      width: 80px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2f3238;
      line-height: 22px;
    }
  }
  .label {
    width: 928px;
    height: 68px;
    display: flex;
    .label-item {
      cursor: pointer;
      margin-left: 0px;
      margin-top: 8px;
      width: 210px;
      height: 68px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      .item-img {
        margin-left: 16px;
        margin-top: 12px;
        width: 44px;
        height: 44px;
      }
      .spans {
        margin-left: 14px;
        margin-top: 12px;
        width: 120px;
        height: 44px;

        .span-t1 {
          margin-top: 3px;
          width: 120px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2f3238;
          line-height: 20px;
          display: block;
        }
        .span-t2 {
          margin-top: 3px;
          width: 120px;
          height: 17px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
          display: block;
        }
      }
    }
  }
}
</style>
